
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/why-typingmentor",
      function () {
        return require("private-next-pages/why-typingmentor.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/why-typingmentor"])
      });
    }
  